import styled, { css } from 'styled-components';

import { colors } from 'styles/theme/colors';

type InfoChipSize = 'default' | 'small';

type Props = {
  $backgroundColor?: string;
  $color?: string;
  $maxWidth?: number;
  $size?: InfoChipSize;
} & React.HTMLAttributes<HTMLDivElement>;

const sizeStyles = {
  default: css`
    font-size: 12px;
    padding: 8px;
    border-radius: 3px;
  `,
  small: css`
    font-size: 10px;
    padding: 4px 8px;
    border-radius: 2px;
  `,
};

const InfoChip = styled.div<Props>`
  background-color: ${({ $backgroundColor }) => $backgroundColor || colors.black05};
  color: ${({ $color }) => $color || colors.black75};
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: default;
  max-width: ${({ $maxWidth }) => ($maxWidth ? `${$maxWidth}px` : 'none')};
  ${({ $size = 'default' }) => sizeStyles[$size]}
`;

export default InfoChip;
